// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grounding-row[data-v-b17404dc]{margin:.35rem 0 .5rem 2.6rem}.grounding-chip[data-v-b17404dc]{display:inline-flex;align-items:center;gap:.4rem;padding:.35rem .7rem;border:1px solid #e0e0e0;border-radius:12px;background:#f7f8fa;color:#888;font-size:.78rem;-webkit-user-select:none;-moz-user-select:none;user-select:none}.grounding-row.is-none .grounding-chip[data-v-b17404dc]{border-color:#f0d8b8;background:#fdf6ec;color:#a8762a}", ""]);
// Exports
module.exports = exports;
